export const IconArrowRight = ({ width = 18 }) => {
  return (
    <svg width={width} height={width} viewBox="0 0 16 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.90495 1.76188L13.667 13.5239L1.90495 25.286" stroke="#2F3234" strokeWidth="3" />
    </svg>
  );
};
